import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1d8f110"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-container" }
const _hoisted_2 = ["poster"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "found-gem",
  class: "big-header"
}, " You found a gem! ", -1))
const _hoisted_5 = { id: "view-button" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" View contents ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", {
      autoplay: "",
      muted: "",
      poster: _ctx.getPoster,
      id: "gem-video"
    }, [
      _createElementVNode("source", {
        src: _ctx.getVideo,
        type: "video/mp4"
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_van_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('next-stage'))),
        size: "large"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}